export const environment = {
  production: false,
  config: {
    apiKey: 'AIzaSyAkjlFQ_O-orOMS3W8D3PHNGCEv17qrv1k',
    authDomain: 'augmented-campus-staging.firebaseapp.com',
    databaseURL: 'https://augmented-campus-staging.firebaseio.com',
    projectId: 'augmented-campus-staging',
    storageBucket: 'augmented-campus-staging.appspot.com',
    messagingSenderId: '960559058799',
  },
};
